import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_GET_PRESCRIPTION_BY_APPOINTMENT } from "../../action-types/actions";
import { getLocalizedErrorMessage } from "../../utils/messageHelper";
import i18n from "../../i18n";

export const getPrescriptionByAppointment = createAsyncThunk(
  ACTIONS_GET_PRESCRIPTION_BY_APPOINTMENT.get_prescription_by_appointment,
  async (appointmentId, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getPrescriptionByAppointment}/${appointmentId}`,
      );

      if (response?.status === 200 || response?.data?.status === true) {
        return response.data;
      } else {
        // Don't show error toast if no prescription found (null is valid)
        if (response?.data?.data === null) {
          return response.data;
        }
        // Use localized error message
        const message = getLocalizedErrorMessage({ response }, i18n);
        toast.error(message);
        return rejectWithValue(response.data);
      }
    } catch (error) {
      // Don't show error toast if no prescription found (404 is expected)
      if (
        error?.response?.status === 404 ||
        error?.response?.data?.data === null
      ) {
        return { status: true, data: null, message: i18n.t("toast.noPrescriptionFound") };
      }

      // Only show toast for actual errors, not "not found" cases
      if (error?.response?.status !== 404) {
        // Use localized error message
        const message = getLocalizedErrorMessage(error, i18n);
        toast.error(message);
      }
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);
